import { Script, injector } from '../shared/injector.js';

import $ from 'jquery';


injector.injectClass(class extends Script {
    onLoad() {
        $('#get_url,#cancel_invoice').on('click', function () {
            const $btn = $(this);
            const $alert = $btn.prev('.alert');
            if ($alert.hasClass('hidden')) {
                $alert.removeClass('hidden');
                return false;
            }
        });
    }
}, ['pending-invoice']);
